/*
 * *****************************************************************************
 *  Copyright (C) 2020 Testsigma Technologies Inc.
 *  All rights reserved.
 *  ****************************************************************************
 */

export enum TestCaseStatus {
  DRAFT = "DRAFT",
  IN_REVIEW = "IN_REVIEW",
  READY = "READY",
  OBSOLETE = "OBSOLETE",
  REWORK = "REWORK"
}
